module.exports = __webpack_public_path__ + "static/media/beacontree_logo_full.c41e2e82.png";